import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { ProviderTypeService } from '@service/provider-type.service';
import {
  FormControl,
  Validators,
  FormGroup,
  FormBuilder
} from '@angular/forms';
import { ProviderType } from '@models/masters/provider-type.model';
import { RoutingHelper } from '@helpers/routinghelper';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpBaseService } from '@service/http-base.service';
import { MatDialog } from '@angular/material/dialog';
import { CustomWarningDialogComponent } from '@module/custom-warning-popup/custom-warning.component';
import { AuthTokenHelper } from '@helpers/auth-token-helper';
import { AuthService } from '@service/auth.sevice';

@Component({
  selector: 'app-custom-form-dialog',
  templateUrl: './custom-form-dialog.component.html',
  styleUrls: ['./custom-form-dialog.component.sass']
})
export class CustomFormDialogComponent {
  public action: string;
  public dialogTitle: string;
  providerTypeForm: FormGroup;
  providerType: ProviderType;
  isActive = false;
  disabled = false;
  submitted = false;
  public apiURL = null;
  @Input() providerTypeId: number;
  getURL: string;
  returnUrl: string;

  constructor(
    private cdf: ChangeDetectorRef,
    public dialogRef: MatDialogRef<CustomFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public providerTypeService: ProviderTypeService,
    private fb: FormBuilder,
    private router: Router,
    private httpService: HttpBaseService,
    private dialog?: MatDialog,
    private route?: ActivatedRoute,
    private routingHelper?: RoutingHelper,
    private authHelper?: AuthTokenHelper,
    private authService?: AuthService,
  ) {

    // Set the defaults
    dialogRef.disableClose = true;
    this.action = data.action;
    if (this.action === 'edit') {
      this.dialogTitle = 'Edit ' + data.patient.Name;
      this.providerType = data.patient;
    } else {
      this.dialogTitle = 'New Provider Type';
      this.providerType = new ProviderType();
    }
    this.providerTypeForm = this.createForm();
  }
  ngOnInit() {
    this.providerTypeId = this.routingHelper.GetRoutingParamerterId(this.route.params);
    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}`;
      this.getURL = this.apiURL + 'providertype/GetProviderList/';
    });

    this.httpService.getAPIURL().subscribe(url => {
      this.apiURL = `${url.API_URL}`;
    });
    let token = this.authHelper.GetAuthorizationTokenValue();
    this.authService.IsTokenExpired(token);

    // get return url from route parameters or default to '/'
    this.returnUrl = '/providerType/patient';
  }
  formControl = new FormControl('', [
    Validators.required
    // Validators.email,
  ]);
  getErrorMessage() {
    return this.formControl.hasError('required')
      ? 'Required field'
      : this.formControl.hasError('email')
      ? 'Not a valid email'
      : '';
  }
  //ngOnInit() {
  //}
  ngOnChanges() {
    this.cdf.detectChanges();
  }
  createForm(): FormGroup {
    return this.fb.group({
      Id: [this.providerType.Id],
      Name: [this.providerType.Name],
      Description: [this.providerType.Description],
      DisplayInList: [this.providerType.DisplayInList],
      DisplayName: [this.providerType.DisplayName],
    });
  }
  submit() {    
    this.submitted = true;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  public confirmAdd(): void {
    this.submitted = false;
    let providerType = this.providerTypeForm.getRawValue();
    providerType.DisplayName = providerType.Name;
    if (providerType.Id > 0) {
      this.providerTypeService.updateProviderType(providerType);
    }
    else {
      this.providerTypeService.addProviderType(providerType);
    }    
  }

  validateInactive() {  
     let providerTypeDialog = this.providerTypeForm.getRawValue();  
    if (providerTypeDialog.Id > 0 && providerTypeDialog.DisplayInList == false) {
      let url = this.apiURL + "providertype/isassociated/" + providerTypeDialog.Id;

      this.httpService.get(url, null, true).subscribe(res => {      
        if (res == true) {
          this.dialogRef.disableClose = false;
          this.submitted = true;
          const dialogRef = this.dialog.open(CustomWarningDialogComponent, {
            width: '400px',
            data: {
              header: "Are you sure?",
              body: "This provider type is associated to the system. Do you want to inactive?",
            },
          });
          dialogRef.afterClosed().subscribe((result) => {
            this.dialogRef.disableClose = true;
            this.submitted = false;
            if (result && providerTypeDialog.DisplayInList == false)
              this.providerType.DisplayInList = false;
            else 
              this.providerType.DisplayInList = true;            
           
          });         
        }
      });
    }
  }

  closeDialog() {   
    if (this.dialogRef.disableClose)
    {
      this.dialogRef.close();
    }      
    let providerTypeDialog = this.providerTypeForm.getRawValue();
    if (providerTypeDialog.DisplayInList == false) {
      this.providerType.DisplayInList = true;
    }
    else
    {
      this.providerType.DisplayInList = false;
    }
  }
}
